export default __webpack_public_path__ + "static/media/lcdChair.1c7fa95e.png";